import { Button } from 'kl-b2c-ui-kit';
import styled from 'styled-components';
import {
    colorBlack,
    colorWhite,
    mediaMd,
    mediaSm,
    mediaXs,
} from 'theme/theme-helper-selectors';

export const Title = styled.h1`
    font-size: 72px;
    line-height: 72px;
    font-weight: 400;
    color: ${colorWhite};
    margin: 0 0 20px 0;

    @media (${mediaXs}) {
        font-size: 32px;
        line-height: 36px;
        margin: 0 0 16px 0;
    }
`;

export const Subtitle = styled.p`
    font-size: 24px;
    line-height: 27px;
    color: ${colorWhite};
    max-width: 650px;
    font-weight: 300;

    margin: 0 0 32px 0;

    @media (${mediaXs}) {
        font-size: 18px;
        line-height: 21px;

        margin: 0 0 20px 0;
    }
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: auto;

    @media (${mediaMd}) {
        margin-top: 0;
    }

    @media (${mediaSm}) {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 20px;
    }
`;

export const IntroButton = styled(Button)`
    border-radius: 8px;
    font-size: 21px;
    line-height: 24px;
    font-weight: 500;
    color: ${colorBlack};

    background: linear-gradient(
        95.33deg,
        rgba(124, 255, 233, 1),
        rgba(187, 193, 254, 1)
    );

    max-height: 58px;
    min-width: 213px;
    padding: 17px 24px;
    letter-spacing: 0;

    @media (${mediaMd}) {
        font-size: 16px;
        line-height: 20px;
        padding: 14px 25px;
        min-width: 176px;
    }
`;

export const HeaderContainer = styled.div`
    min-height: 410px;
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 10;

    @media (${mediaMd}) {
        min-height: 452px;
    }

    @media (${mediaSm}) {
        min-height: 300px;
    }
`;

export const DescriptionItemsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;

    @media (${mediaSm}) {
        display: none;
    }
`;

export const SliderContainer = styled.div`
    display: none;

    @media (${mediaSm}) {
        display: block;
    }
`;

export const BrandDescription = styled.div`
    margin: 60px 0 100px;
    display: flex;
    align-items: flex-end;
    gap: 40px;

    @media (${mediaMd}) {
        margin: 20px 0 60px;
    }

    @media (${mediaXs}) {
        margin: 20px 0 85px;
    }
`;

export const BrandParagraph = styled.p`
    font-size: 24px;
    line-height: 27px;
    font-weight: 300;
    color: ${colorWhite};
    margin-bottom: 28px;

    @media (${mediaMd}) {
        font-size: 21px;
        line-height: 24px;
    }

    @media (${mediaXs}) {
        font-size: 14px;
        line-height: 16px;
    }
`;

export const BrandText = styled.div``;

export const BrandTitle = styled.p`
    font-weight: 300;
    font-size: 32px;
    line-height: 27px;
    color: ${colorWhite};

    @media (${mediaMd}) {
        font-size: 24px;
        line-height: 26px;
    }

    @media (${mediaXs}) {
        font-size: 16px;
        line-height: 16px;
    }
`;

export const BrandImage = styled.div`
    flex-shrink: 0;

    img {
        width: 460px;
        height: 390px;
        transform: scale(1.5);

        @media (${mediaMd}) {
            width: 300px;
            height: 310px;
        }
    }

    @media (${mediaSm}) {
        display: none;
    }
`;
